import { OptionsIcon } from "@/Icons/v2/Options";
import { useTrans } from "@/translations";

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { twMerge } from "tailwind-merge";

import { ChartTypeSelector } from "./components/chartTypeSelector";
import { ComparisonBenchmarks } from "./components/comparisonBenchmarks";
import { RecyclingTargetView } from "./components/recyclingTargetView";

export const RecyclingRateOptions: React.FC = () => {
  const { t } = useTrans();

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <PopoverButton
            className={twMerge(
              "flex items-center gap-1.5 rounded-lg border px-[14px] py-[8px] text-[13px] font-semibold",
              open
                ? "border-black bg-black text-white"
                : "border-grey3 bg-white text-black",
            )}
          >
            <OptionsIcon />
            {t("homePage:optionsButtonText")}
          </PopoverButton>
          <PopoverPanel
            anchor="bottom end"
            className="border-grey3 z-[10000] mt-[4.95px] w-[320px] overflow-hidden rounded-lg border bg-white shadow-lg"
          >
            <ChartTypeSelector />

            <RecyclingTargetView />

            <ComparisonBenchmarks />
          </PopoverPanel>
        </>
      )}
    </Popover>
  );
};
